import React, { useState } from 'react';
import { Button } from '@saleshandy/design-system';
import SearchInput from '../../../../../../../../shared/design-system/components/atoms/search-input';
import LinkBadge from '../../../../../../../../shared/design-system/components/atoms/link-badge';
import { IconPlace } from '../../../../../../../../shared/design-system/components/dropdown';
import { GlobalSettings } from '../../../../../../../../shared/components/global-settings-wrapper';
import {
  DoNotCallListsFilter,
  ModalActions,
} from '../../../../../../types/do-not-call-list';
import { isWhitelabelWithoutClientView } from '../../../../../../../../shared/utils/user-details';
import { isInternalUrl } from '../../../../../../../../shared/utils/is-internal-url';
import { supportUrls } from '../../../../../../../../shared/utils/urls';
import { accessibleOnClick } from '../../../../../../../../shared/utils';
import hasPermission from '../../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../../shared/utils/access-control/enums/permissions';

type IProps = {
  filters: DoNotCallListsFilter;
  onFiltersChange: (payload: Partial<DoNotCallListsFilter>) => void;
  onAddList: (action: ModalActions) => void;
  isAgencyConfigRequestPending?: boolean;
};

const DoNotCallListHeader: React.FC<IProps> = ({
  filters,
  onFiltersChange,
  onAddList,
  isAgencyConfigRequestPending,
}) => {
  const [search, setSearch] = useState(filters.search || '');

  const onSearch = () => {
    onFiltersChange({ search, page: 1 });
  };

  const onClearSearch = () => {
    setSearch('');
    onFiltersChange({ search: '', page: 1 });
  };

  return (
    <GlobalSettings.Header className="do-no-contact-list-header">
      <GlobalSettings.HeaderLeft>
        <GlobalSettings.HeaderTitle
          title="Do Not Call List"
          isToolTip={true}
          tooltipText="Create a do-not-call list to prevent reaching out to prospects you shouldn't call."
        />
        {isWhitelabelWithoutClientView() &&
          (!isAgencyConfigRequestPending || isInternalUrl()) && (
            <LinkBadge url={supportUrls.callDncBlogURL} />
          )}
      </GlobalSettings.HeaderLeft>
      <GlobalSettings.HeaderRight>
        <SearchInput
          searchValue={search}
          setSearchValue={setSearch}
          onSearch={onSearch}
          onClearSearch={onClearSearch}
          searchIconPlace={IconPlace.Left}
          searchIconFixed
          placeholder="Search"
          className="dnc-search-input"
        />

        {hasPermission(Permissions.DNC_WRITE) && (
          <Button {...accessibleOnClick(() => onAddList('add'))}>
            Add List
          </Button>
        )}
      </GlobalSettings.HeaderRight>
    </GlobalSettings.Header>
  );
};

export default DoNotCallListHeader;
